function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.861 22.698v-19.192h-27.723v19.192h13.328v2.062l-5.056 2.8 0.516 0.933 5.073-2.81 5.073 2.81 0.516-0.933-5.056-2.8v-2.062h13.328zM3.205 4.572h25.59v17.060h-25.59v-17.060z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.294 15.427l-3.162-4.41-2.116 4.103-3.327-6.713-2.429 8.965 1.029 0.279 1.694-6.25 3.014 6.082 2.284-4.428 3.414 4.761 2.948-9.892-1.021-0.305z",
  fill: "#000000"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.464 9.903c-1.764 0-3.199 1.435-3.199 3.199s1.435 3.199 3.199 3.199c1.763 0 3.198-1.435 3.198-3.199s-1.435-3.199-3.198-3.199zM23.464 15.235c-1.176 0-2.133-0.956-2.133-2.133s0.957-2.133 2.133-2.133c1.176 0 2.132 0.956 2.132 2.133s-0.956 2.133-2.132 2.133z",
  fill: "#000000"
});

var SvgDisplay1 = function SvgDisplay1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDisplay1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/display1.7308a0d9.svg";
export { ForwardRef as ReactComponent };